import React, {useEffect} from "react";
import {GenericField} from "../../common/GenericField";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {
    setErrorData,
    setForename,
    setNewPassword,
    setPassword,
    setRepeatedPassword,
    setSurname,
    setUsername
} from "../../../../slices/userProfileSlice";
import {useGetTranslation} from "../../../../hooks/useGetTranslation";
import {setCmsInEditMode, setDashboardInEditMode} from "../../../../slices/globalParamsSlice";
import {PasswordField} from "./PasswordField";

export const UserProfileForm = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {userData} = useSelector(state => state.userProfile.getUserProfile);
    const {errorData} = useSelector(state => state.userProfile.updateUserProfile);
    const {
        username,
        forename,
        surname,
        password,
        newPassword,
        repeatedPassword,
    } = useSelector((state) => state.userProfile.form);
    const getTranslation = useGetTranslation();
    const {currentView} = useSelector(state => state.globalParams.globalParams);
    const viewPrefix = currentView?.split('/')[0];

    useEffect(() => {
        const fillUserProfile = () => {
            if (!userData) return;
            dispatch(setUsername(userData.username));
            dispatch(setForename(userData.forename));
            dispatch(setSurname(userData.surname));
        }
        fillUserProfile();
    }, [dispatch, userData])

    const setEditMode = () => {
        if (viewPrefix === 'dashboard') {
            dispatch(setDashboardInEditMode(true));
        } else {
            dispatch(setCmsInEditMode(true));
        }
    }


    const handleUsernameChange = e => {
        dispatch(setUsername(e.target.value));
        setEditMode();
    }

    const handleForenameChange = e => {
        dispatch(setForename(e.target.value));
        setEditMode();
    }

    const handleSurnameChange = e => {
        dispatch(setSurname(e.target.value));
        setEditMode();
    }

    const handlePasswordChange = e => {
        dispatch(setPassword(e.target.value));
        setEditMode();
    }

    const handleNewPasswordChange = e => {
        dispatch(setNewPassword(e.target.value));
        setEditMode();
    }

    const handleRepeatedPasswordChange = e => {
        dispatch(setRepeatedPassword(e.target.value));
        setEditMode();
    }

    return (
        <>
            <div>
                <div className={'form-group-header'}>
                    {t('userData')}
                </div>
                <GenericField id={'username'}
                              type={'text'}
                              name={t('username')}
                              placeholder={t('typeUsername')}
                              value={username}
                              onChange={handleUsernameChange}
                              required={true}
                              readOnly={true}
                              disabled={true}
                              error={errorData}
                              errorSetter={setErrorData}
                />
                <GenericField id={'forename'}
                              type={'text'}
                              name={t('forename')}
                              placeholder={t('typeForename')}
                              value={forename}
                              onChange={handleForenameChange}
                              required={true}
                              error={errorData}
                              errorSetter={setErrorData}
                />
                <GenericField id={'surname'}
                              type={'text'}
                              name={t('surname')}
                              placeholder={t('typeSurname')}
                              value={surname}
                              onChange={handleSurnameChange}
                              required={true}
                              error={errorData}
                              errorSetter={setErrorData}
                />
                <GenericField id={'roles'}
                              type={'text'}
                              name={t('roles')}
                              placeholder={''}
                              value={userData?.roles.map(role => getTranslation(role.displayedName)).join(', ')}
                              onChange={() => {
                              }}
                              readOnly={true}
                              disabled={true}
                />
            </div>
            <div>
                <div className={'form-group-header'}>
                    {t('changePassword')}
                </div>
                <div>
                    <PasswordField id={'password'}
                                  type={'password'}
                                  name={t('oldPassword')}
                                  placeholder={t('typeOldPassword')}
                                  value={password}
                                  onChange={handlePasswordChange}
                                  error={errorData}
                                  errorSetter={setErrorData}
                    />
                    <PasswordField id={'newPassword'}
                                  type={'password'}
                                  name={t('newPassword')}
                                  placeholder={t('typeNewPasswordField')}
                                  value={newPassword}
                                  onChange={handleNewPasswordChange}
                                  error={errorData}
                                  errorSetter={setErrorData}
                    />
                    <PasswordField id={'repeatedPassword'}
                                  type={'password'}
                                  name={t('repeatPassword')}
                                  placeholder={t('repeatNewPassword')}
                                  value={repeatedPassword}
                                  onChange={handleRepeatedPasswordChange}
                                  error={errorData}
                                  errorSetter={setErrorData}
                    />
                </div>
            </div>
        </>
    );
}